import { StatusMessageType } from "Shared/util/custom-hooks";
import { Nothing, PaymentInformationMessageResource } from "Shared/util/types";

export const BIC_HANDELSBANKEN = "HANDSESS";
export const BIC_SWEDBANK = "SWEDSESS";

export type PayoutInformationStatusMessageState = {
    link: string | Nothing;
    linkText: string | Nothing;
    text: string | Nothing;
    type: StatusMessageType;
};

export type PayoutInformationStatusMessageProps = {
    bic: string | Nothing;
    message: PaymentInformationMessageResource | Nothing;
};

export type StatusMessageTranslation = {
    link?: string;
    linkText?: string;
    text: string;
};
